module.exports = __webpack_public_path__ + "img/kachel-einzelneprodukte_PROBALANCE.74245396.png";